import { CSSProperties, FC, memo, useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import classNames from 'classnames'

import css from './CustomCursorWorkHover.module.scss'

import routes from '@/data/routes'

import PillButton from '@/components/PillButton/PillButton'

export type CustomCursorWorkHoverProps = {
  className?: string
  text?: string
}

const CustomCursorWorkHover: FC<CustomCursorWorkHoverProps> = ({ className, text }) => {
  const [cursorPosition, setCursorPosition] = useState<{ x: number; y: number } | null>(null)
  const [cursorVisibility, setCursorVisibility] = useState(false)
  const [pillTheme, setPillTheme] = useState<'dark' | 'light'>('dark')
  const [forceHide, setForceHide] = useState(false)
  const router = useRouter()

  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      const isHeading = target?.classList?.contains('WorkHoverHeading')

      if (isHeading) {
        setCursorPosition({ x: e.clientX, y: e.clientY })
        setCursorVisibility(true)
        setPillTheme(target?.classList?.contains('theme-dark') ? 'dark' : 'light')
      } else {
        setCursorVisibility(false)
      }
    }

    document.addEventListener('mousemove', handleMouseMove)

    return () => {
      document.removeEventListener('mousemove', handleMouseMove)
    }
  }, [])

  // @NOTE: Bit of a hack to remove the cursor when navigating away from the work page
  useEffect(() => {
    if (router.asPath !== routes.Work.path) {
      setForceHide(true)
    }
  }, [router.asPath])

  return (
    <div
      className={classNames('CustomCursorWorkHover', css.root, className, {
        [css.visible]: cursorVisibility,
        [css.forceHide]: forceHide
      })}
      style={{ '--x': `${cursorPosition?.x ?? 0}px`, '--y': `${cursorPosition?.y ?? 0}px` } as CSSProperties}
    >
      <div className={css.buttonWrapper}>
        <PillButton className={css.button} theme={pillTheme}>
          {text}
        </PillButton>
      </div>
    </div>
  )
}

export default memo(CustomCursorWorkHover)
